export default "__VITE_ASSET__DsF6UKgg__"